"use strict";
/*
 * Created on 28.11.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author MSu
 */


var WindowActionContextConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowActionContextConverter, _DataObjectConverter_);

  function WindowActionContextConverter() {
    _classCallCheck(this, WindowActionContextConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowActionContextConverter).apply(this, arguments));
  }

  return WindowActionContextConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowActionContextConverter = WindowActionContextConverter;